import axios from '../../core/services/axios';

export const getProspects = (params) => axios.get('/api/get-prospects', { params });

/** With initiative_id & organization_id */
export const generateRoute = (data) => axios.post('/api/walk-routes', data);

// eslint-disable-next-line camelcase
export const attachPetitionToProspect = (prospect_id, petition_id, signature_line) =>
  axios.post(`/api/prospects/${prospect_id}/attach-petition`, { petition_id, signature_line });

export const detachProspectFromPettion = (prospectId) =>
  axios.post(`/api/prospects/${prospectId}/detach-petition`);
